import React from "react";

const BlogSix = () => {
  const blogs = [
    {
      image: "/images/keyword/23.jpg",
      title: "Tempo Traveller Hire in Pune",
      para:
        "Book comfortable Tempo Traveller services in Pune with Aaradhya Travels for family trips, corporate tours, weddings, and outstation travel.",
      date: "20 June",
      link: "/tempo-traveller-hire-pune",
    },
    {
      image: "/images/keyword/4.jpg",
      title: "Mini Bus On Rent in Pune",
      para:
        "Affordable Mini Bus rental in Pune for group tours, school trips, office outings, and local sightseeing with professional drivers.",
      date: "22 June",
      link: "/mini-bus-rental-pune",
    },
    {
      image: "/images/keyword/17.jpg",
      title: "Luxury Bus Rental in Pune",
      para:
        "Luxury bus rental services in Pune with premium seating, AC coaches, and modern amenities for comfortable group travel.",
      date: "25 June",
      link: "/luxury-bus-rental-pune",
    },
  ];

  return (
    <section className="blog-six section-space">

      {/* Background */}
      <div
        className="blog-six__bg"
        style={{
          backgroundImage: "url('/images/shapes/blgo-6-1.png')",
        }}
      ></div>

      <div className="container">

        {/* Title */}
        <div className="sec-title sec-title--two text-center">
          <h6 className="sec-title__tagline">Latest Blog</h6>
          <h3 className="sec-title__title">Our Latest Blog</h3>
        </div>

        {/* Blog Items */}
        <div className="row gutter-y-30">

          {blogs.map((item, index) => (
            <div className="col-lg-4 col-md-6" key={index}>

              <div className="blog-six__item borderrr">

                {/* Image */}
                <div className="blog-six__item__image">

                  <img
                    src={item.image}
                    alt={item.title}
                    className="img-fluid"
                  />

                  <a
                    href={item.link}
                    className="blog-six__item__image__hover"
                  ></a>

                </div>

                {/* Content */}
                <div className="blog-six__item__content">

                  <h3 className="blog-six__item__title">
                    <a href={item.link} className="darkcolorrrr">
                      {item.title}
                    </a>
                  </h3>

                  {/* Paragraph */}
                  <p className="blog-six__item__text">
                    {item.para}
                  </p>

                  {/* Meta */}
                  {/* <ul className="blog-six__item__meta list-unstyled">

                    <li>
                      <a href={item.link}>
                        <i className="icon-user-1"></i> by Admin
                      </a>
                    </li>

                    <li>
                      <a href={item.link}>
                        <i className="icon-comment--icon"></i> 2 comments
                      </a>
                    </li>

                  </ul> */}

                  {/* Date */}
                  {/* <div className="blog-six__item__date">
                    <span>{item.date.split(" ")[0]}</span>
                    {item.date.split(" ")[1]}
                  </div> */}

                </div>

              </div>

            </div>
          ))}

        </div>

      </div>

      {/* Shapes */}
      <div className="blog-six__element-one">
        <img src="/images/shapes/blog-angle-1-1.png" alt="shape" />
      </div>

      <div className="blog-six__element-two">
        <img src="/images/shapes/blog-angle-1-1.png" alt="shape" />
      </div>

    </section>
  );
};

export default BlogSix;